import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gcccr7fgc5: FaireBrandEntity = {
  token: "b_gcccr7fgc5",
  type: "brand",
  name: "Jewel Pledge",
  avatarUrl:
    "https://cdn.faire.com/fastly/e1a0d689fa822dc27473c47b286c263705c34d1799936cda8115fa483b0d91f3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c4b02f2da540028241da8bca44f4163839a8b8be94dfc9b32b8319e050ba8695.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e1a0d689fa822dc27473c47b286c263705c34d1799936cda8115fa483b0d91f3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c4b02f2da540028241da8bca44f4163839a8b8be94dfc9b32b8319e050ba8695.jpeg",
  location: "los angeles, CA, USA",
  minimumOrderDollars: 69,
  rating: 5,
  reviewCount: 47,
  productCount: 2681,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Jewel Pledge, where your next stunning creation begins! We're a family-run business with a deep passion for the art of jewelry making. For years, we've dedicated ourselves to sourcing a highly curated collection of trending quality beads, jewelry charms, chains, and more!\n\nOur pride lies in the relationships we've built—not just with our customers, but with the talented artisans we work with directly. This close connection ensures that every piece in our collection meets our high standards for quality and craftsmanship. We believe that great jewelry starts with great components, and we're excited to share our passion and expertise with you.\n\nAt Jewel Pledge, we're more than just a shop; we're a community built on a shared love for creativity. Thank you for choosing us to be a part of your journey.",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:09.432Z",
    importedBy: "entity-db-cli",
  },
};
